import React from "react";
import InvoiceList from "./InvoiceList";
export default function Offers() { return <InvoiceList kind="offer" />; }
